import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitojaipurcab() {



  const cardData = {
    keyword: " Mumbai to Jaipur Cab",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Jaipur cab service, providing safe, comfortable, and affordable long-distance travel for families, tourists, corporate travelers, and group journeys. Jaipur, the capital of Rajasthan, is located approximately 1100–1200 km from Mumbai and is one of India’s most popular tourist destinations known for its royal heritage, forts, palaces, and vibrant culture. Our professional drivers ensure a smooth, secure, and stress-free interstate journey with proper rest stops and comfortable travel experience. We offer flexible options including one-way drops, round trips, multi-day travel plans, and customized Rajasthan tour packages. Our fleet includes economy sedans, premium sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for all group sizes. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai to Jaipur cab service.",

"topPlaces": [
  {
    "title": "Hawa Mahal",
    "description": "Hawa Mahal, also known as the Palace of Winds, is one of Jaipur’s most iconic landmarks built with pink sandstone. It features hundreds of small windows designed for royal women to observe street life while staying unseen. Its unique honeycomb structure and architectural beauty make it a must-visit attraction for tourists traveling from Mumbai."
  },
  {
    "title": "Amber Fort",
    "description": "Amber Fort is a majestic hilltop fort known for its grand courtyards, artistic halls, and stunning views of the surrounding landscape. Visitors can explore royal rooms, Sheesh Mahal, and enjoy elephant rides, making it a highlight of Jaipur tourism."
  },
  {
    "title": "City Palace",
    "description": "City Palace is a royal residence showcasing a blend of Rajasthani and Mughal architecture. It houses museums, courtyards, and royal artifacts that reflect Jaipur’s rich history and regal lifestyle."
  },
  {
    "title": "Jantar Mantar",
    "description": "Jantar Mantar is a UNESCO World Heritage Site featuring a collection of astronomical instruments built by Maharaja Jai Singh II. It is a fascinating place for learning about ancient Indian astronomy and scientific achievements."
  },
  {
    "title": "Nahargarh Fort",
    "description": "Nahargarh Fort offers breathtaking panoramic views of Jaipur city, especially during sunset. It is a popular spot for photography, evening outings, and enjoying the scenic beauty of the Pink City."
  },
  {
    "title": "Jaigarh Fort",
    "description": "Jaigarh Fort is known for housing the world’s largest cannon on wheels, Jaivana Cannon. It is a well-preserved fort offering insights into military architecture and stunning views of Amber Fort and surrounding hills."
  },
  {
    "title": "Jal Mahal",
    "description": "Jal Mahal is a beautiful palace located in the middle of Man Sagar Lake. It is known for its scenic beauty and architectural elegance, making it a popular photography spot for tourists."
  },
  {
    "title": "Birla Mandir Jaipur",
    "description": "Birla Mandir is a stunning white marble temple dedicated to Lord Vishnu and Goddess Lakshmi. It offers a peaceful spiritual atmosphere and is beautifully illuminated in the evening."
  },
  {
    "title": "Bapu Bazaar",
    "description": "Bapu Bazaar is a vibrant shopping market known for textiles, handicrafts, jewelry, and traditional Rajasthani items. It is a must-visit for tourists looking to experience Jaipur’s local culture and shopping."
  },
  {
    "title": "Albert Hall Museum",
    "description": "Albert Hall Museum is the oldest museum in Rajasthan, showcasing artifacts, paintings, sculptures, and historical items. Its Indo-Saracenic architecture and rich collection make it an important cultural attraction in Jaipur."
  }
],






services: [
  {
    name: "Mumbai to Jaipur Cab",
    description: "Mumbai to Jaipur cab service offers a comfortable long-distance journey to the Pink City of Rajasthan. Ideal for tourists, families, and business travelers, this service ensures smooth highway travel with experienced drivers. Well-maintained vehicles provide maximum comfort. It guarantees a safe and hassle-free travel experience."
  },
  {
    name: "Mumbai to Jaipur Taxi",
    description: "Mumbai to Jaipur taxi provides private and convenient intercity travel with door-to-door pickup. This service is ideal for long-distance journeys with flexible schedules. Comfortable vehicles ensure a pleasant ride. It guarantees a smooth and reliable journey."
  },
  {
    name: "Mumbai to Jaipur Cab Service",
    description: "Mumbai to Jaipur cab service offers professional travel solutions with multiple vehicle options. This service is ideal for family trips, tours, and corporate travel. Clean vehicles and trained drivers ensure comfort. It ensures a dependable travel experience."
  },
  {
    name: "Mumbai to Jaipur Taxi Service",
    description: "Mumbai to Jaipur taxi service ensures dependable transportation with comfortable vehicles and experienced chauffeurs. This service is suitable for long-distance travel. Flexible booking options enhance convenience. It guarantees a smooth journey."
  },
  {
    name: "Cab from Mumbai to Jaipur",
    description: "Cab from Mumbai to Jaipur offers a convenient way to travel between cities with complete comfort. This service is ideal for those who prefer road travel over flights. Professional drivers ensure safe journeys. It ensures a relaxed experience."
  },
  {
    name: "Taxi from Mumbai to Jaipur",
    description: "Taxi from Mumbai to Jaipur provides reliable long-distance travel for individuals and groups. This service ensures smooth highway journeys with experienced drivers. Comfortable seating enhances the experience. It guarantees a dependable ride."
  },
  {
    name: "Mumbai to Jaipur Cab Booking",
    description: "Mumbai to Jaipur cab booking allows customers to reserve their ride easily with flexible options. Travelers can choose vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Jaipur Taxi Booking Online",
    description: "Mumbai to Jaipur taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai to Jaipur Cab Price",
    description: "Mumbai to Jaipur cab price varies based on vehicle type, distance, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Mumbai to Jaipur Taxi Fare",
    description: "Mumbai to Jaipur taxi fare is designed to be competitive for long-distance travel. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Jaipur One Way Cab",
    description: "Mumbai to Jaipur one way cab offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Mumbai to Jaipur Round Trip Taxi",
    description: "Mumbai to Jaipur round trip taxi provides complete travel solutions including return journeys. This service is ideal for vacations and business trips. Flexible schedules and comfortable vehicles enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Jaipur Innova Cab",
    description: "Mumbai to Jaipur Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating and smooth performance enhance long journeys. It ensures a comfortable intercity experience."
  },
  {
    name: "Mumbai to Jaipur Ertiga Cab",
    description: "Mumbai to Jaipur Ertiga cab offers affordable and spacious travel for small groups and families. Comfortable seating and good mileage make it ideal for long-distance journeys. It ensures a pleasant trip."
  },
  {
    name: "Mumbai to Jaipur Sedan Cab",
    description: "Mumbai to Jaipur sedan cab is ideal for individuals and small families seeking economical travel. Sedans offer smooth rides and comfort for long journeys. Professional drivers ensure safety. It ensures a relaxed journey."
  },
  {
    name: "Mumbai to Jaipur SUV Taxi",
    description: "Mumbai to Jaipur SUV taxi provides spacious and comfortable travel for groups. SUVs offer better performance and extra luggage space. Suitable for long-distance journeys. It ensures a comfortable travel experience."
  }
],

tableData: [
  ["Mumbai to Jaipur Cab", "Mumbai to Jaipur Taxi"],
  ["Mumbai to Jaipur Cab Service", "Mumbai to Jaipur Taxi Service"],
  ["Cab from Mumbai to Jaipur", "Taxi from Mumbai to Jaipur"],
  ["Mumbai to Jaipur Cab Booking", "Mumbai to Jaipur Taxi Booking Online"],
  ["Mumbai to Jaipur Cab Price", "Mumbai to Jaipur Taxi Fare"],
  ["Mumbai to Jaipur One Way Cab", "Mumbai to Jaipur Round Trip Taxi"],
  ["Mumbai to Jaipur Innova Cab", "Mumbai to Jaipur Ertiga Cab"],
  ["Mumbai to Jaipur Sedan Cab", "Mumbai to Jaipur SUV Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Jaipur Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Jaipur cab service, ideal for long-distance travel, family trips, and business journeys."
  },
  {
    WhyChooseheading: "Experienced Interstate Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in interstate routes, ensuring safe driving, smooth navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Perfect for Rajasthan Tours",
    WhyChoosedescription: "Plan your Jaipur trip with ease using our reliable cab services, perfect for sightseeing, tourism, and family vacations."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day Rajasthan travel plans."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Jaipur cab service operates 24/7, allowing flexible departure anytime as per your schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Long-Distance Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Jaipur cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Jaipur cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Jaipur for one-way and round trips." },
  { question: "What is the distance between Mumbai and Jaipur?", answer: "The distance is approximately 1100 to 1200 km and takes around 18 to 22 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Jaipur cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is this suitable for family travel?", answer: "Yes, our service is ideal for family, business, and group travel." },
  { question: "Do you provide interstate travel permits?", answer: "Yes, all required permits are arranged for smooth interstate travel." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Sharma",
    feedback: "The Mumbai to Jaipur journey with Royal Route Cabs was very comfortable and well-managed. The long-distance travel felt safe and smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Agarwal",
    feedback: "Excellent service for our Mumbai to Jaipur trip. The cab was clean, the driver was professional, and the entire journey was hassle-free and relaxing.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Jaipur Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-jaipur-cab.jpg", // replace if needed
  "description": "Book Mumbai to Jaipur cab service with Royal Route Cabs for safe, reliable, and comfortable long-distance travel. Available for one-way and round-trip journeys with sedan, SUV, Innova, and Ertiga vehicles. 24x7 outstation taxi service from Mumbai to Jaipur.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "14999", // approx starting fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-jaipur-cab"
  }
};



  return (
    <div>
<Helmet>
  <title>Mumbai to Jaipur Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Jaipur cab with Royal Route Cabs. Safe and affordable long-distance taxi service with sedan, SUV, Innova & Ertiga cars. 24x7 reliable intercity travel."
  />

  <meta
    name="keywords"
    content="mumbai to jaipur cab, mumbai to jaipur taxi, mumbai to jaipur cab service, mumbai to jaipur taxi service, cab from mumbai to jaipur, taxi from mumbai to jaipur, mumbai to jaipur cab booking, mumbai to jaipur taxi booking online, mumbai to jaipur cab price, mumbai to jaipur taxi fare, mumbai to jaipur one way cab, mumbai to jaipur round trip taxi, mumbai to jaipur innova cab, mumbai to jaipur ertiga cab, mumbai to jaipur sedan cab, mumbai to jaipur suv taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/65.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitojaipurcab;